import React from 'react';
import { Header, Grid, Input } from 'semantic-ui-react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';

class Stocksdetails extends React.Component {

  state = {
    data: []
  }

  componentDidMount() {
    this.getstockdetails();
  }

  componentDidUpdate(props) {
    if (props.partno != this.props.partno || props.brandId != this.props.brandId) {
      this.getstockdetails();
    }
  }

  getstockdetails() {

    let context = this;
    context.setState({ load: true, message: 'Getting Other Branch Stock Details!!!' });
    let data1 = { 'brand_id': this.props.brandId, 'partno': this.props.partno };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchasedetail/getstockdetails.php',
      success: function(data) {
        context.setState({ load: false });
        try {
          data = JSON.parse(data);
          console.log(data);
          console.log('popopops');
          for (var i = 0; i < data.length; i++) {
            data[i].sino = i + 1;
          }
          context.setState({
            data: data,
          })
        } catch (e) {
          console.log(e);
          console.log('popopopopo');
        }
      },
      error: function(err)
      {
        console.log('popopopopo');
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  render() {
    const { data } = this.state;
    return (
      <div>
      { data.length > 0 ?
        (
          <div>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                <b>Branch Stock Deatil</b>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                <table width='100%' id='table'>
                  <tr>
                    <th id='tableheader'>Branch</th>
                    <th id='tableheader'>Brand</th>
                    <th id='tableheader'><center>Stocks</center></th>
                    <th id='tableheader'><center>Min_Ord_Qty</center></th>
                  </tr>
                  { data.map((z) =>{
                      return(
                        <tr>
                          <td><center>{z.branch_name}</center></td>
                          <td><center>{z.brand_name}</center></td>
                          <td><center>{z.stock}</center></td>
                          <td><center>{z.min_order_qty}</center></td>
                        </tr>
                      );
                    })
                  }
                </table>
              </Grid.Column>
            </Grid>
          </div>
        ) :
        (
          <div>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                <b>Other Branch Stock</b>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                <center style={{color: 'red'}}>No stock(s) available in other branch!!!</center>
              </Grid.Column>
            </Grid>
          </div>
        )
      }
      </div>
    );
  }
}

export default Stocksdetails;
